import { type CybusDetailedService, ResourceType } from '../../../domain'

import { BulkDeleteResourceUsecase, BulkDisableResourceUsecase, BulkEnableResourceUsecase } from '../Resources'

export class BulkEnableServiceUsecase extends BulkEnableResourceUsecase {
    protected readonly type = ResourceType.SERVICE

    selectServices (ids: readonly CybusDetailedService['id'][] | null): void {
        this.select(ids)
    }

    override enable (): Promise<void> {
        return super.enable()
    }
}

export class BulkDeleteServicesUsecase extends BulkDeleteResourceUsecase {
    protected readonly type = ResourceType.SERVICE

    selectServices (ids: readonly CybusDetailedService['id'][] | null): void {
        this.select(ids)
    }

    override delete (): Promise<void> {
        return super.delete()
    }
}

export class BulkDisableServicesUsecase extends BulkDisableResourceUsecase {
    protected readonly type = ResourceType.SERVICE

    selectServices (ids: readonly CybusDetailedService['id'][] | null): void {
        this.select(ids)
    }

    override disable (): Promise<void> {
        return super.disable()
    }
}
